var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-middle d-inline-block unexplored-marker-container"},[_c('div',{staticClass:"unexplored-marker rounded-circle",attrs:{"aria-label":"Tab is unexplored"}})])
}]

export { render, staticRenderFns }